import React, { useEffect, useRef } from 'react';

const ScrollProgress = () => {
  const barRef = useRef(null);

  useEffect(() => {
    let ticking = false;

    const updateProgress = () => {
      const scrollHeight = document.documentElement.scrollHeight - window.innerHeight;
      let progress = 0;
      if (scrollHeight > 0) {
        progress = window.scrollY / scrollHeight;
      }
      
      if (barRef.current) {
        barRef.current.style.transform = `scaleX(${progress})`;
      }
      ticking = false;
    };

    const handleScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(updateProgress);
        ticking = true;
      }
    };

    // Initial call to set the progress if page is reloaded scrolled down
    updateProgress();

    window.addEventListener('scroll', handleScroll, { passive: true });
    window.addEventListener('resize', handleScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleScroll);
    };
  }, []);

  return (
    <div className="fixed top-0 left-0 w-full h-1 z-[9999] pointer-events-none">
      <div 
        ref={barRef}
        className="h-full bg-gradient-to-r from-primary to-[#0047b3] will-change-transform shadow-[0_0_10px_rgba(0,102,255,0.7)]"
        style={{ 
          transform: `scaleX(0)`,
          transformOrigin: 'left'
        }}
      ></div>
    </div>
  );
};

export default ScrollProgress;
